import axios, { AxiosError } from "axios";
import domain from './domen'
import { IRegForm, IRegResponsFunction } from "../Intarfaces/IReg";

const sleep = (ms:number) => new Promise(
    resolve => setTimeout(resolve, ms));

export default class RegAPI{
    
    static async reg(form:IRegForm):Promise<IRegResponsFunction>{
        
        try{
            const response = await axios.post(domain+'/register', form,{
                headers:{
                    "Content-Type":"application/json"
                }
            })

            console.log(response.data);
            
    
            if(response.status===200){
                return {status:200, message:"Регистрация завершена"} as IRegResponsFunction
            }

            if(response.status===400&& response.data){

            }
            return {status:response.status, message:"Ошибка"} as IRegResponsFunction
        }
        catch(error){

            let er = error as AxiosError<{detail:string}>
            
            if(er.response?.data.detail==="Email already exists"){
                return {status:0, message:"На данный  E-mail уже зарегестрированна учётная запись"} as IRegResponsFunction
            }

            return {status:0, message:"Ошибка"} as IRegResponsFunction
            
        }

        
        
    }

}